<template>
  <router-view :key="$route.fullPath"/>
  <!-- .row -->
</template>

<script>
// import ListEntries from '@/views/entry/ListEntries.vue'
export default {
  //components: { ListEntries },
  props: ['uid'],
  mounted() {
    // console.log('uid: ' + this.uid)
    this.$store.dispatch('user/fetchUser', this.uid)
  }
}
</script>

<style scoped>
</style>
